import React from 'react';
import { useEditorPlan } from './useEditorPlan';
import { Form2 } from '../../../../toolympus/components/primitives/Forms2';
import { EditorPlan } from './EditorPlan';
import { IconButton } from '@mui/material';
import { RefreshOutlined } from '@mui/icons-material';
import { OccupyFreeSpace } from '../../../../toolympus/components/primitives';

interface Props {
  
}

export const EditorPlanPage = (props: Props) => {
  const data = useEditorPlan();
  return (
    <Form2
      title="Загрузка редактора"
      fitFullHeight
      background="panel"
      formBodyProps={{ style: { padding: 0 }}}
      headerItems={<>
        <OccupyFreeSpace />
        <IconButton size="small" onClick={() => data.applicableProjects.reload()}>
          <RefreshOutlined />
        </IconButton>
      </>}>
      <EditorPlan
        data={data}
        />
    </Form2>
  );
}
